// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__lK3gv","inner":"Form_inner__2FvCG","range":"Form_range__3d0PA","name":"Form_name__ODdB6","actions":"Form_actions__7iO_y"};